import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { sessionAwareStorage } from '@/shared/utils/storage'
import { seedClaims, type Claim } from './data'

// ponytail: API 전 데모. AS 와 같은 방식으로 브라우저에만 저장한다.
export const useClaimStore = create<{ claims: Claim[]; save: (claim: Claim) => void }>()(
  persist(
    (set) => ({
      claims: seedClaims,
      save: (claim) =>
        set((state) => ({ claims: [claim, ...state.claims.filter((c) => c.id !== claim.id)] })),
    }),
    { name: 'qsc-claim-demo-v1', storage: sessionAwareStorage },
  ),
)
